// src/hooks/layout/useLowCurrentLayout.js
// Zayıf Akım (Telekom) paftası layout hook'u
import { useEffect, useRef, useMemo } from 'react';
import * as THREE from 'three';
import { useSelector, shallowEqual } from 'react-redux';
import { getFloorSortOrder } from '../../redux/floorPlanSlice';
import { renderFloorPlanDocuments, disposeGroup } from './layoutUtils';

export const useLowCurrentLayout = (scenesRef, sceneTabId) => {
  const TARGET_TAB = sceneTabId || 'telekom';
  const allGroupsRef = useRef([]);
  const boundsRef = useRef({});
  const documentBoundsRef = useRef([]);

  // Sadece mimari allIds değişince yeniden hesapla (tüm tab objesi yerine)
  const mimariAllIds = useSelector(
    state => state.floorPlans.tabs?.mimari?.allIds || [],
    shallowEqual
  );
  const mimariById = useSelector(state => state.floorPlans.tabs?.mimari?.byId);
  const sitePlan = useSelector(state => state.utils.sitePlan);

  // Mimari floor plan'larını grup referanslarıyla birlikte al ve sırala
  // Sadece allIds veya byId referansı değişince çalışır
  const floorPlans = useMemo(() => {
    if (!mimariAllIds.length || !mimariById) return [];
    return mimariAllIds
      .map(id => mimariById[id])
      .filter(p => p && p.group)
      .sort((a, b) => getFloorSortOrder(a.type, a.number) - getFloorSortOrder(b.type, b.number));
  }, [mimariAllIds, mimariById]);

  // Kat planı dokümanlarını sahneye render et
  useEffect(() => {
    if (!scenesRef?.current) return;
    if (!floorPlans || floorPlans.length === 0) return;

    // Sahneyi oluştur (yoksa)
    if (!scenesRef.current[TARGET_TAB]) {
      scenesRef.current[TARGET_TAB] = new THREE.Scene();
    }
    const scene = scenesRef.current[TARGET_TAB];

    const result = renderFloorPlanDocuments({
      scene,
      floorPlans,
      sitePlan: sitePlan?.width ? sitePlan : null,
    });

    if (result) {
      allGroupsRef.current = result.allGroups;
      boundsRef.current = result.bounds;
      documentBoundsRef.current = result.documentBounds;
    }

    return () => {
      if (result) {
        disposeGroup(result.mainFrameGroup);
        scene.remove(result.mainFrameGroup);
        allGroupsRef.current = [];
        boundsRef.current = {};
        documentBoundsRef.current = [];
      }
    };
  }, [floorPlans, sitePlan?.width, sitePlan?.height]);

  return { allGroupsRef, boundsRef, documentBoundsRef };
};
